module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', [_c('div', {
    staticClass: "name ellipse"
  }, [_vm._v(_vm._s(_vm.rewardInfo.deliveryName))]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.rewardInfo.deliveryEnounce))])]), _vm._v(" "), _c('img', {
    staticClass: "headImg",
    attrs: {
      "src": _vm.rewardInfo.deliveryAvatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "href": 'tel:' + _vm.rewardInfo.deliveryTel
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".21rem",
      "height": ".21rem",
      "margin-right": ".07rem"
    },
    attrs: {
      "src": require("../assets/images/reward-tel.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v("电话联系")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".2rem",
      "background": "#F5F5F5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("打赏西游侠")]), _vm._v(" "), (!_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "des"
  }, [_vm._v("打赏将全额转给同学，平台不扣取任何费用")]) : _vm._e(), _vm._v(" "), (!_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "items-box"
  }, _vm._l((_vm.rewardInfo.configList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "reward-items"
    }, [_c('img', {
      staticClass: "avater",
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "reward-price"
    }, [_vm._v(_vm._s(item.type ? '其他金额' : '¥' + item.amount))]), _vm._v(" "), _c('span', {
      staticClass: "reward-btn",
      on: {
        "click": function($event) {
          return _vm.openReward(item)
        }
      }
    }, [_vm._v("打赏")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "receive-reward"
  }, [_c('img', {
    staticStyle: {
      "width": "2.28rem",
      "height": "2.08rem"
    },
    attrs: {
      "src": require("../assets/images/delivery.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#2F2F2F"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": ".34rem",
      "font-weight": "700"
    }
  }, [_vm._v("已收到打赏"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rewardInfo.orderRewardAmount) + "元")]), _vm._v("。谢谢您！")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".26rem",
      "margin-top": ".12rem"
    }
  }, [_vm._v("感谢您的认可，我会继续努力！")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reward-bottom"
  }, [_c('div', {
    staticClass: "reward-number"
  }, [_vm._v("他收到过" + _vm._s(_vm.rewardInfo.deliveryRewardCounts) + "次打赏")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    on: {
      "click": function($event) {
        return _vm.toRewardList(_vm.rewardInfo.deliveryId)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.rewardOrderList), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "reward-img",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    })
  }), 0), _vm._v(" "), (_vm.rewardInfo.rewardOrderList.length > 0) ? _c('img', {
    staticStyle: {
      "display": "block",
      "width": ".14rem",
      "height": ".24rem"
    },
    attrs: {
      "src": require("../assets/images/reward-arrow.png"),
      "alt": ""
    }
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.isShowReward) ? _c('div', {
    staticClass: "reward_mask"
  }, [_c('div', {
    staticClass: "reward_box"
  }, [_c('img', {
    staticClass: "reward-close",
    attrs: {
      "src": require("../assets/images/reward-close.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeMask()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reward-tit"
  }, [_vm._v("感谢您的一份心意")]), _vm._v(" "), _c('div', {
    staticClass: "amount-box"
  }, [_c('span', {
    staticStyle: {
      "font-family": "PingFangSC-Medium",
      "font-size": ".42rem",
      "color": "#2F2F2F",
      "margin-right": ".2rem"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: [_vm.isActive ? 'active' : 'noActive'],
    staticStyle: {
      "width": "2.5rem",
      "outline": "none"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入1-50元的金额"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, function($event) {
        return _vm.changeAmount(_vm.amount)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reward-submit",
    on: {
      "click": function($event) {
        return _vm.submitReward(1)
      }
    }
  }, [_vm._v("确定打赏")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-fa18a6e6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reward.vue
// module id = 464
// module chunks = 7